var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTips48Filled = function SvgIconTips48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3A16.7 16.7 0 1 0 40.7 24 16.72 16.72 0 0 0 24 7.3Zm1.7 25h-3.35v-3h3.4l-.05 3Zm.45-7.06a1.001 1.001 0 0 0-.45.88v1h-3.35v-1a4.309 4.309 0 0 1 2.44-4 1.48 1.48 0 0 0 1-1.86 1.76 1.76 0 0 0-1.22-1.23 1.84 1.84 0 0 0-1.61.31 1.79 1.79 0 0 0-.7 1.43h-3.4a5.191 5.191 0 0 1 2-4.12 5.269 5.269 0 0 1 4.55-.91 5.18 5.18 0 0 1 3.66 3.67 4.85 4.85 0 0 1-2.92 5.78v.05Z",
    fill: "current"
  })));
};
export default SvgIconTips48Filled;